import { useEffect } from "react";
import { TextField, Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  setDialog,
  resetForm,
  Group,
} from "../../../../app/slices/groupSlice";
import { Controller, useForm } from "react-hook-form";
import { HiOutlineUserGroup, HiOutlineDocumentText } from "react-icons/hi2";
import FormDialog, { SectionCard } from "../../../../components/FormDialog";

const GroupsForm = () => {
  const _Groups = useSelector((state) => state.group.group);
  const _SearchBody = useSelector((state) => state.group.searchBody);

  const isAdd = _Groups.form.id ? false : true;
  const { control, reset, watch, register, handleSubmit, setValue } = useForm({
    defaultValues: _Groups.form,
  });


  const onSubmit = (data) => {
    if (isAdd) {
      dispatch(Group.create(data));
    } else {
      dispatch(Group.update(data.id, data, _SearchBody));
    }
  };

  useEffect(() => {
    return () => {
      dispatch(resetForm());
    };
  }, []);

  const dispatch = useDispatch();

  const handlDialog = () => {
    dispatch(setDialog());
  };

  return (
    <FormDialog
      open={_Groups.dialog}
      onClose={handlDialog}
      icon={<HiOutlineUserGroup />}
      title={isAdd ? "إضافة مجموعة" : "تعديل المجموعة"}
      subtitle={
        isAdd
          ? "أدخل معلومات المجموعة لإضافتها"
          : "قم بتحديث معلومات المجموعة ثم احفظ التغييرات"
      }
      onSubmit={handleSubmit(onSubmit)}
    >
      <SectionCard icon={<HiOutlineDocumentText />} title="معلومات المجموعة">
        <Grid item xs={12}>
          <Controller
            name="name"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="الاسم"
                fullWidth
                {...field}
              />
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default GroupsForm;
